<template>
  <div>
    <v-row>
      <v-col cols="4">
        <v-text-field
          label="Фамилия"
          outlined
          v-model="v.lastName.$model"
          :errorMessages="getValidationErrorText(v.lastName)"
        />
      </v-col>
      <v-col cols="4">
        <v-text-field
          label="Имя"
          outlined
          v-model="v.firstName.$model"
          :errorMessages="getValidationErrorText(v.firstName)"
        />
      </v-col>
      <v-col cols="4">
        <v-text-field
          label="Отчество (при наличии)"
          outlined
          v-model="v.patronymic.$model"
          :errorMessages="getValidationErrorText(v.patronymic)"
        />
      </v-col>
    </v-row>

    <IdentityDocument :v="v" />

    <v-row>
      <v-col cols="6">
        <v-text-field
          v-model="v.snils.$model"
          :errorMessages="getValidationErrorText(v.snils)"
          label="СНИЛС"
          v-mask="['###-###-### ##']"
          outlined
          :disabled="true"
        />
      </v-col>
      <v-col cols="6">
        <v-text-field
          v-model="v.inn.$model"
          :errorMessages="getValidationErrorText(v.inn)"
          label="ИНН"
          v-mask="['############']"
          outlined
          :disabled="true"
        />
      </v-col>
      <v-col cols="12">
        <v-checkbox
          v-model="v.isBusinessman.$model"
          :label="FieldLabel.APPLICANT_IS_BUSINESSMAN"
        />
      </v-col>
      <v-col v-if="v.isBusinessman.$model" cols="4">
        <v-text-field
          v-model="v.ogrn.$model"
          :errorMessages="getValidationErrorText(v.ogrn)"
          v-mask="Mask.OGRNIP"
          :label="FieldLabel.OGRNIP"
          outlined
        />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import IdentityDocument, {
  identityDocumentModel,
  identityDocumentValidation,
} from '@/components/services/ROD/StepApplicant/Manual/IdentityDocument';
import {
  maxLength,
  minLength,
  required,
  requiredIf,
} from 'vuelidate/lib/validators';
import {
  INN_ROD,
  MAX_LENGTH,
  MinLength,
  PERSON_NAME,
  SNILS_ROD,
} from '@/utils/validate';
import { getValidationErrorText } from '@/utils/validate';
import { FieldLabel, Mask } from '@/constants';

export const personModel = {
  isBusinessman: false,
  lastName: '',
  firstName: '',
  patronymic: '',
  snils: '',
  inn: '',
  ogrn: '',
  identityDocument: { ...identityDocumentModel },
};

export const personValidation = {
  isBusinessman: {},
  lastName: {
    required,
    maxLength: maxLength(MAX_LENGTH),
    PERSON_NAME,
  },
  firstName: {
    required,
    maxLength: maxLength(MAX_LENGTH),
    PERSON_NAME,
  },
  patronymic: {
    maxLength: maxLength(MAX_LENGTH),
    PERSON_NAME,
  },
  snils: {
    required,
    minLength: minLength(MinLength.SNILS),
    SNILS: SNILS_ROD,
  },
  inn: {
    required,
    minLength: minLength(12),
    INN: INN_ROD,
  },
  ogrn: {
    required: requiredIf('isBusinessman'),
    minLength: minLength(MinLength.OGRNIP),
  },
  identityDocument: identityDocumentValidation,
};

export default {
  name: 'Person',
  props: {
    v: {
      type: Object,
      required: true,
    },
  },
  components: {
    IdentityDocument,
  },
  data: () => ({
    FieldLabel,
    Mask,
    getValidationErrorText,
  }),
};
</script>
